module.exports = new __parcel__URL__("bossfight_notification_title_text.efd633e9.png").toString();